import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import "../../assets/css/modal.css";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { FiX, FiLock } from 'react-icons/fi';
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { turnOffButton, turnOnButton } from "./buttonFunctions"
import { doneLoading, load, submitReset, clearUserState } from '../../actions/userActions';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import './ConfirmPassword.css';


const ResetSuccess = (props) => {
  return (
    <Modal
      show={props.show}
      dialogClassName="rs-dialog"
      contentClassName="rs-content"
      centered
      onHide={() => { props.clearUserState(); props.closeModal(); }}
    >
      <Modal.Body className="rs-body">
        <button
          type="button"
          className="rs-close-btn"
          aria-label="Close"
          onClick={() => { props.clearUserState(); props.closeModal(); }}
        >
          <FiX />
        </button>
        <div className="rs-icon-ring">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <div className="rs-heading">GREAT!</div>
        <p className="rs-subtext">Your password has been changed successfully.</p>
      </Modal.Body>
      <Modal.Footer className="rs-footer">
        <button
          type="button"
          className="rs-cta-btn"
          onClick={() => { props.clearUserState(); props.closeModal(); }}
        >
          START ORDERING NOW!
        </button>
        <div className="rs-powered">Powered by Warely</div>
      </Modal.Footer>
    </Modal>
  );
};



const ConfirmPassword = (props) => {
  const { register, reset, handleSubmit } = useForm()
  const [password, setPassword] = useState("")
  const [password_confirm, setCfmPassword] = useState("")
  const [showPass, setShowPass] = useState(false)
  const [showConfirmPass, setShowConfirmPass] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const buttonElement = useRef(null)

  useEffect(() => {
    turnOffButton(buttonElement.current)
    if (password === "" || password_confirm === "") {
      turnOffButton(buttonElement.current)
    } else if (password === password_confirm) {
      turnOnButton(buttonElement.current)
    }
  }, [password, password_confirm])

  useEffect(() => {
    if (props.user.reset) {
      props.confirmationVisibility(false)
      props.hideResetPassword()
      setShowSuccess(true)
    }
  }, [props.user.reset])

const onSubmit = () => {
  const business_id = Number(localStorage.getItem("business_id"));
  const location_id = Number(localStorage.getItem("location_id"));

    const newData = { ...props.resetData, "password": password, "password_confirmation": password_confirm,     
      business_id: business_id,
      location_id: location_id }
    props.submitReset(newData)
  }

  const onClick = () => {
    props.confirmationVisibility(false)
    props.setResetData({})
  }

  return (
    <>
      <ResetSuccess show={showSuccess} closeModal={props.goToLogin
        ? () => { props.clearUserState(); setShowSuccess(false); props.goToLogin(); }:() => { props.close() }} clearUserState={props.clearUserState} goToLogin={props.goToLogin} />
      <Modal
        show={props.show}
        dialogClassName="cfp-dialog"
        contentClassName="cfp-content"
        centered
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body className="cfp-body">
            <button type="button" className="cfp-close-btn" aria-label="Close" onClick={onClick}>
              <FiX />
            </button>

            <div className="cfp-icon-ring">
              <FiLock size={28} color="#fff" />
            </div>
            <div className="cfp-heading">Change password</div>
            <div className="cfp-subtitle">Enter and confirm your new password below</div>

            <div className="cfp-field">
              <label className="cfp-label">New password</label>
              <div className="cfp-pw-wrap">
                <input
                  type={showPass ? "text" : "password"}
                  className="cfp-input"
                  required
                  autoComplete="off"
                  placeholder="Enter new password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button type="button" className="cfp-eye-btn" onClick={() => setShowPass(!showPass)}>
                  {showPass ? <IoEye size={18} /> : <IoEyeOff size={18} />}
                </button>
              </div>
            </div>

            <div className="cfp-field">
              <label className="cfp-label">Confirm password</label>
              <div className="cfp-pw-wrap">
                <input
                  type={showConfirmPass ? "text" : "password"}
                  className="cfp-input"
                  required
                  autoComplete="off"
                  placeholder="Re-enter new password"
                  onChange={(e) => setCfmPassword(e.target.value)}
                />
                <button type="button" className="cfp-eye-btn" onClick={() => setShowConfirmPass(!showConfirmPass)}>
                  {showConfirmPass ? <IoEye size={18} /> : <IoEyeOff size={18} />}
                </button>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="cfp-footer">
            <button
              className="cfp-submit-btn"
              type="submit"
              ref={buttonElement}
              disabled
              style={{ opacity: 0.5 }}
            >
              Submit
            </button>
            <div className="cfp-powered">Powered by Warely</div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.user
})

export default withTranslation()(
  connect(mapStateToProps, {
    load, doneLoading, submitReset, clearUserState
  })(ConfirmPassword)
);